// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
// COMPONENTS
// ICONS
import { FaDollarSign, FaCheck } from 'react-icons/fa';
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import FormBlock from '../../components/FormBlock';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import InputBlock from '../../components/InputBlock';
import FileUploadBlock from '../../components/FileUploadBlock';
import CheckboxBlock from '../../components/CheckboxBlock';
import Button from '../../components/Button';
import ActionBlock from '../../components/ActionBlock';
import LoadingScreen from '../../components/LoadingScreen';

// SERVICES AND HELPERS
import { Alert } from '../../helpers/Alert';
import * as Helper from '../../helpers/helper';
import CompanyCreateValidator from '../../helpers/validators/product-management/CompanyCreateValidator';
import CompanyBonusLevelValidator from '../../helpers/validators/product-management/CompanyBonusLevelValidator';
import * as CompanyService from '../../services/company.service';
import * as CompanyBonusLevelService from '../../services/companybonuslevel.service';
import * as UserService from '../../services/user.service';

var timeoutId = 0;

const CreateNewClientPage = (props) => {
    const { location } = props
    const urlId = location.pathname.split('/').pop();
    const [companyId, setCompanyId] = useState(parseInt(urlId) == urlId ? urlId : 0);
    const initialState = {
        id: companyId,
        businessName: "",
        contactName: "",
        contactEmail: "",
        contactPhone: "",
        logoFile: [],
        isActive: true,
        canAccessSalesTools: false,
        initialUser: {
            firstName: "",
            lastName: "",
            username: "",
            password: "",
            confirmPassword: "",
            phoneNumber: "",
            email: "",
            isAdmin: true,
            isSalesCoach: false,
            companyId: companyId
        }
    }

    const [bonusLevelId, setBonusLevelId] = useState(0);
    const bonusLevelInitialState = {
        id: bonusLevelId,
        breakpoint: 0,
        reward: 0,
        isActive: true,
        companyId: companyId
    }

    const [loading, setLoading] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [isCheckingBonusLevel, setIsCheckingBonusLevel] = useState(false);
    const [isUsed, setIsUsed] = useState(false);

    const [company, setCompany] = useState(initialState);
    const [bonusLevels, setBonusLevels] = useState([]);
    const [bonusLevel, setBonusLevel] = useState(bonusLevelInitialState);

    const [logoFile, setLogoFile] = useState(null);
    const [logoPath, setLogoPath] = useState(null);

    useEffect(() => {
        if (companyId > 0) {
            setLoading(true);
            CompanyService.Get(companyId).then(res => {
                setCompany(res);
                setLogoPath(res.logoPath);
                LoadBonusLevels();
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
        }
    }, [])

    const DeleteCompanyImage = (path) => {
        CompanyService.DeleteCompanyImage(companyId, path)
            .then(res => {
                Alert({ success: true, message: 'Image has been removed!' });
            }).catch(ex => { });
    }

    const checkName = (e) => {
        clearTimeout(timeoutId);
        setIsChecking(true);
        timeoutId = setTimeout(() => {
            formik.setFieldTouched('businessName');
            if (e != undefined && e.target.value == company.businessName) {
                setIsUsed(false);
                setIsChecking(false);
            }
            else
                CompanyService.Check(e == undefined ? formik.values.businessName : e.target.value).then(res => {
                    setIsUsed(res);
                    setIsChecking(false);
                });
        }, 300);
    }

    const checkBonusLevel = (e) => {
        clearTimeout(timeoutId);
        setIsCheckingBonusLevel(true);
        timeoutId = setTimeout(() => {
            bonusFormik.setFieldTouched('breakpoint');
            if (e != undefined && e.target.value == bonusLevel.breakpoint) {
                setIsUsed(false);
                setIsCheckingBonusLevel(false);
            }
            else
                CompanyBonusLevelService.Check(e == undefined ? bonusFormik.values.breakpoint : e.target.value, companyId).then(res => {
                    setIsUsed(res);
                    setIsCheckingBonusLevel(false);
                });
        }, 300);
    }

    const LoadBonusLevels = () => {
        CompanyBonusLevelService.GetAll(companyId).then(res => {
            setLoading(false);
            setBonusLevels(res);
        });
    }

    const CreateCompany = (values, setSubmitting) => {
        if (isUsed)
            return;
        setLoading(true);
        CompanyService.Save(Helper.ConvertJsonToFormData({
            ...values,
            logoFile: logoFile ? logoFile[0].file : null
        })).then(res => {
            setCompany(res);
            setLogoPath(res.logoPath);
            if (companyId == 0) {
                formik.setFieldValue("initialUser.companyId", res.id);
                if (formik.values.initialUser.username != "") {
                    UserService.Save(values.initialUser).then(res => {
                        setSubmitting(false);
                        setLoading(false);
                        Alert({ success: true, message: "Company and User have been saved!" });
                    }).catch(ex => {
                        setSubmitting(false);
                        setLoading(false);
                    });
                }
                else {
                    setSubmitting(false);
                    setLoading(false);
                    Alert({ success: true, message: "Company has been saved!" });
                }
            }
            else {
                setSubmitting(false);
                setLoading(false);
                Alert({ success: true, message: "Company has been saved!" });
            }

        }).catch(ex => {
            setSubmitting(false);
            setLoading(false);
        });
    }

    const SaveBonusLevel = (values, setSubmitting) => {
        if (isUsed)
            return;
        setLoading(true);
        CompanyBonusLevelService.Save(values)
            .then(res => {
                setBonusLevelId(0);
                setBonusLevel(null);
                setBonusLevel({ id: 0, breakpoint: 0, reward: 0, isActive: true, companyId: companyId });
                setSubmitting(false);
                Alert({ success: true, message: "Bonus Level has been saved!" });
                CompanyBonusLevelService.GetAll(companyId).then(res => {
                    setLoading(false);
                    setBonusLevels(res);
                });
            }).catch(ex => {
                setSubmitting(false);
                setLoading(false);
            });
    }

    const formik = useFormik({
        initialValues: company,
        enableReinitialize: true,
        validationSchema: CompanyCreateValidator,
        onSubmit: (values, { setSubmitting }) => {
            CreateCompany(values, setSubmitting);
        }
    })

    const bonusFormik = useFormik({
        initialValues: bonusLevel,
        enableReinitialize: true,
        validationSchema: CompanyBonusLevelValidator,
        onSubmit: (values, { setSubmitting }) => {
            SaveBonusLevel(values, setSubmitting);
        }
    })

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style">
                                <ContentHeader
                                    title={(companyId > 0 ? "Update" : "Add New") + " Company"}
                                    headerSize="sm"
                                />
                                <FormBlock onSubmit={formik.handleSubmit} className="border-bottom" style={{ paddingBottom: 30, marginBottom: 30 }}>
                                    <Section removeContainer className={companyId > 0 ? "" : "border-bottom"}>
                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                id="businessName"
                                                inputLabel="Company"
                                                bordered
                                                {...formik.getFieldProps("businessName")}
                                                inputState={
                                                    formik.touched.businessName && (formik.errors.businessName || isUsed)
                                                        ? "error"
                                                        : formik.touched.businessName && formik.errors.businessName == null && !isUsed ? "success" : ""
                                                }
                                                errorMessage={isUsed ? "Name is already in use!" : formik.errors.businessName}
                                                onKeyUp={checkName}
                                                loading={isChecking}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                inputLabel="Contact Name"
                                                bordered
                                                {...formik.getFieldProps("contactName")}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                inputLabel="Contact Email"
                                                bordered
                                                {...formik.getFieldProps("contactEmail")}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                inputLabel="Contact Phone #"
                                                mask="(999) 999-9999"
                                                bordered
                                                {...formik.getFieldProps("contactPhone")}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6} className="padding-vertical">
                                            <CheckboxBlock
                                                label="Is client active?"
                                                id="is-active-checkbox"
                                                defaultChecked={formik.values.isActive}
                                                {...formik.getFieldProps("isActive")}
                                            />
                                            <CheckboxBlock
                                                label="Can access sales tools?"
                                                id="can-access-sales-tool-checkbox"
                                                defaultChecked={formik.values.canAccessSalesTools}
                                                {...formik.getFieldProps("canAccessSalesTools")}
                                            />
                                            <CheckboxBlock
                                                label="Is Months Required for Media Buy(s) and Bonus Buy(s)?"
                                                id="isMonthsRequired"
                                                defaultChecked={formik.values.isMonthsRequired}
                                                {...formik.getFieldProps("isMonthsRequired")}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <FileUploadBlock
                                                labelIdle='Upload Logo'
                                                clearAction
                                                onupdatefiles={setLogoFile}
                                                path={logoPath}
                                                onClick={DeleteCompanyImage}
                                            />
                                        </ContentBlock>
                                    </Section>
                                    {
                                        companyId > 0 ? <></> :
                                            <Section removeContainer className="padding-vertical">
                                                <ContentHeader
                                                    title="Create Admin User (optional)"
                                                    headerSize="sm"
                                                />
                                                <Section /> {/* this is just for formatting */}
                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        inputLabel="First Name"
                                                        bordered
                                                        {...formik.getFieldProps("initialUser.firstName")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        inputLabel="Last Name"
                                                        bordered
                                                        {...formik.getFieldProps("initialUser.lastName")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        inputLabel="Username"
                                                        bordered
                                                        {...formik.getFieldProps("initialUser.username")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        inputLabel="Email"
                                                        bordered
                                                        {...formik.getFieldProps("initialUser.email")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        inputLabel="Password"
                                                        bordered
                                                        type="password"
                                                        {...formik.getFieldProps("initialUser.password")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        inputLabel="Confirm Password"
                                                        bordered
                                                        type="password"
                                                        {...formik.getFieldProps("initialUser.confirmPassword")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        inputLabel="Phone #"
                                                        bordered
                                                        mask="(999) 999-9999"
                                                        {...formik.getFieldProps("initialUser.phoneNumber")}
                                                    />
                                                </ContentBlock>
                                            </Section>
                                    }
                                    <CustomBlock className="content-container--actions">
                                        <Button
                                            text="Cancel"
                                            to="/companies"
                                            className="danger--bg fit-content"
                                        />
                                        <Button
                                            text="Save"
                                            type="submit"
                                            className="success--bg fit-content"
                                        />
                                    </CustomBlock>
                                </FormBlock>
                                {
                                    companyId > 0 ?
                                        <Section>
                                            <FormBlock onSubmit={bonusFormik.handleSubmit}>
                                                <ContentHeader
                                                    title="Bonus Buy Levels"
                                                    headerSize="sm"
                                                />
                                                <Section removeContainer className="padding-vertical">
                                                    <ContentBlock cols={5}>
                                                        <InputBlock
                                                            id="breakpoint"
                                                            inputLabel="Breakpoint"
                                                            bordered
                                                            {...bonusFormik.getFieldProps("breakpoint")}
                                                            inputState={
                                                                bonusFormik.touched.breakpoint && (bonusFormik.errors.breakpoint || isUsed)
                                                                    ? "error"
                                                                    : bonusFormik.touched.breakpoint && bonusFormik.errors.breakpoint == null && !isUsed ? "success" : ""
                                                            }
                                                            errorMessage={isUsed ? "Bonus Level is already in use!" : bonusFormik.errors.breakpoint}
                                                            onKeyUp={checkBonusLevel}
                                                            loading={isCheckingBonusLevel}
                                                            iconLeft={<FaDollarSign size={17} className="dark-grey--clr" />}
                                                        />
                                                    </ContentBlock>

                                                    <ContentBlock cols={5}>
                                                        <InputBlock
                                                            inputLabel="Reward"
                                                            bordered
                                                            {...bonusFormik.getFieldProps("reward")}
                                                            iconLeft={<FaDollarSign size={17} className="dark-grey--clr" />}
                                                        />
                                                    </ContentBlock>

                                                    <ContentBlock cols={2}>
                                                        <CustomBlock className="content-container--actions">
                                                            <Button
                                                                text="Save"
                                                                type="submit"
                                                                className="success--bg fit-content"
                                                                style={{ marginTop: 10 }}
                                                            />
                                                        </CustomBlock>
                                                    </ContentBlock>
                                                </Section>
                                            </FormBlock>
                                            <CustomBlock className="w-100">
                                                {
                                                    bonusLevels.map((level, index) =>
                                                        <ActionBlock
                                                            className="light--bg"
                                                            title={`Level: $${level.breakpoint} - Reward: $${level.reward}`}
                                                            actionsPosition="left"
                                                            primaryActionText="Edit"
                                                            primaryActionBackground="info--bg"
                                                            primaryActionOnClick={() => {
                                                                CompanyBonusLevelService.Get(level.id).then(res => {
                                                                    setBonusLevel(res);
                                                                });
                                                            }}
                                                            secondaryActionText="Remove"
                                                            secondaryActionBackground="danger--bg"
                                                            secondaryActionOnClick={() => {
                                                                CompanyBonusLevelService.Delete(level.id).then(res => {
                                                                    LoadBonusLevels();
                                                                });
                                                            }}
                                                            toggleIconPosition="right"
                                                            toggleIcon={
                                                                <FaCheck size={20} className={level.isActive ? "success--clr" : "grey--clr"} />
                                                            }
                                                            toggleIconBackground={level.isActive ? "lighter-green--bg" : "lighter-grey--bg"}
                                                            toggleIconOnClick={() => {
                                                                level.isActive = !level.isActive;
                                                                CompanyBonusLevelService.Toggle(level.id).then(res => { })
                                                                    .catch(ex => CompanyService.GetAll(companyId).then(res => setBonusLevels(res)));
                                                            }}
                                                        />
                                                    )
                                                }
                                            </CustomBlock>
                                        </Section>
                                        : <></>
                                }
                            </CustomBlock>
                        </Section>
                    </CustomBlock>
            }
        </>
    );
}

export default CreateNewClientPage;